module.exports = __webpack_public_path__ + "assets1763535487631/img/avator.bd584bb1.png";